import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public corpData: any
  UserName: any;
  private memberUserNameSource = new BehaviorSubject<any>(null);
  memberUserName = this.memberUserNameSource.asObservable();


  constructor(private logger: LoggerService,) { }



  setCorpData(data) {

    this.logger.log(data)
    this.corpData = data
  }

  setUserName(data: string) {
    this.memberUserNameSource.next(data);
  }

  getUserName() {
    return this.UserName;
  }

  getCorpData() {
    return this.corpData
  }




}
